(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["headernew"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reklamation"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.nkComplaintInlineInitialized) return;
  window.nkComplaintInlineInitialized = true;

  function initialize(root) {
    root.querySelectorAll('.nk-complaint__form').forEach(function (form) {
      if (form.dataset.nkInlineReady) return;
      form.dataset.nkInlineReady = 'true';
      var submit = form.querySelector('[type="submit"]');
      if (!submit) return;
      var label = submit.querySelector('span') || submit;
      var originalLabel = label.textContent;
      var status = document.createElement('div');
      status.className = 'nk-complaint__submit-status';
      status.hidden = true;
      status.tabIndex = -1;
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      submit.before(status);
      var another = document.createElement('button');
      another.type = 'button';
      another.className = 'nk-complaint__another';
      another.textContent = 'Weitere Reklamation erfassen';
      another.hidden = true;
      submit.after(another);
      var pending = false;
      var sent = false;

      function message(text, kind) {
        status.textContent = text;
        status.dataset.state = kind;
        status.setAttribute('role', kind === 'error' ? 'alert' : 'status');
        status.hidden = false;
      }
      function endpoint() {
        var value = form.getAttribute('action');
        if (!value) throw new Error('Der Formulareingang ist noch nicht eingerichtet. Bitte kontaktiere das Naturkindchen-Team.');
        var url = new URL(value, window.location.href);
        if (url.protocol !== 'https:' || !/^\/api\/v1\/public\/complaints\/[a-zA-Z0-9_-]{43}$/.test(url.pathname)) {
          throw new Error('Bitte den AEGIS-Formular-Endpunkt in den Seiteneinstellungen hinterlegen.');
        }
        return url.href;
      }
      try { endpoint(); submit.disabled = false; submit.removeAttribute('aria-disabled'); }
      catch (error) { submit.disabled = true; message(error.message, 'error'); }

      another.addEventListener('click', function () {
        sent = false;
        status.hidden = true;
        another.hidden = true;
        submit.hidden = false;
        submit.disabled = false;
        label.textContent = originalLabel;
        var first = form.querySelector('input:not([type="hidden"]):not([type="checkbox"]):not([type="file"])');
        if (first) first.focus({ preventScroll: true });
      });

      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (pending || sent || !form.reportValidity()) return;
        var controls = [];
        try {
          var target = endpoint();
          var payload = new FormData(form);
          var photos = payload.getAll('Fotos des Defekts[]');
          var receipt = payload.get('Kaufbeleg');
          if (!photos.length || photos.length > 6 || photos.some(function (file) { return !(file instanceof File) || !file.size; })) {
            throw new Error('Bitte 1 bis 6 Fotos des Defekts auswählen.');
          }
          var files = photos.concat(receipt instanceof File ? [receipt] : []);
          if (!(receipt instanceof File) || !receipt.size) throw new Error('Bitte einen Kaufbeleg auswählen.');
          if (files.some(function (file) { return file.size > 5 * 1024 * 1024; })) throw new Error('Eine Datei ist größer als 5 MB. Bitte eine kleinere Datei auswählen.');
          if (files.reduce(function (sum, file) { return sum + file.size; }, 0) > 20 * 1024 * 1024) throw new Error('Alle Dateien zusammen dürfen höchstens 20 MB groß sein.');
          pending = true;
          controls = Array.from(form.querySelectorAll('input, textarea, select, button')).map(function (element) { return { element: element, disabled: element.disabled }; });
          controls.forEach(function (item) { item.element.disabled = true; });
          form.setAttribute('aria-busy', 'true');
          label.textContent = 'Wird übermittelt …';
          message('Deine Reklamation und Dateien werden übermittelt. Bitte einen Moment warten.', 'pending');
          var response = await fetch(target, { method: 'POST', body: payload, credentials: 'omit', mode: 'cors', redirect: 'error', headers: { Accept: 'application/json' } });
          var result;
          try { result = await response.json(); }
          catch (_) { throw new Error('Die Übermittlung konnte nicht bestätigt werden. Bitte kontaktiere uns, bevor du die Reklamation erneut sendest.'); }
          if (!response.ok || result.success !== true) throw new Error(result.message || 'Die Reklamation konnte nicht gespeichert werden. Deine Eingaben bleiben erhalten.');
          sent = true;
          form.reset();
          message(result.message || 'Vielen Dank! Deine Reklamation wurde übermittelt. Wir melden uns bei dir.', 'success');
          submit.hidden = true;
          another.hidden = false;
        } catch (error) {
          message(error instanceof TypeError ? 'Die Übermittlung konnte nicht bestätigt werden. Deine Eingaben bleiben erhalten. Bitte prüfe die Verbindung oder kontaktiere uns.' : error.message, 'error');
        } finally {
          pending = false;
          form.removeAttribute('aria-busy');
          controls.forEach(function (item) { item.element.disabled = item.disabled; });
          if (sent) { submit.disabled = true; another.disabled = false; }
          else label.textContent = originalLabel;
          if (!status.hidden) { status.focus({ preventScroll: true }); status.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
        }
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());


  } catch(e) { console.error(e); }
})();
})();
